import React, { Component } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
// context
import { SendSmsEmailConext } from "../../provider";

//
import { LoaderPage } from "../../../../component/Loader";

// actions
import { sendSmsNotificationAction } from "../../../../actions/sendEmailAndSms.action";

// helpers
import { isFunction } from "lodash";

// templates
import { ProjectMessageTemplate } from "../../projectMessageTemplate";
import { IssueMessageTemplate } from "../../issueMessageTemplate";
import { InfoIcon } from "../../../infoIcon";
import { successToastStyle, errorToastStyle } from "../../../../customToast";

//
import { UserInfo } from "../usersInfo";
import htmlToFormattedText from "html-to-formatted-text";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

class Template extends Component {
  static contextType = SendSmsEmailConext;

  state = {
    toMobileNumbers: "",
    message: "",
    cc: "",
    disabled: false,
    isDataLoaded: false,
    mobileNumberList: [],
    errors: {
      toMobileNumbers: { error: false, message: "Field is required" },
      message: { error: false, message: "Field is required" }
    }
  };

  static getDerivedStateFromProps(props, state) {
    const { mobileNumbers, mobileNumberList, message, disabled } =
      props.templateInfo || {};
    // if form is already submitted
    if (props.templateInfo && disabled) {
      return {
        toMobileNumbers: "",
        message: "",
        cc: [],
        mobileNumberList: [],
        disabled
      };
    }
    // if mails data is empty then do this
    if (props.templateInfo && !state.isDataLoaded && !state.toMobileNumbers) {
      return {
        toMobileNumbers: mobileNumbers,
        mobileNumberList,
        isDataLoaded: true,
        cc: [],
        message,
        disabled
      };
    }
    return null;
  }

  onKeyDown = e => {
    const { which } = e;
    const {
      dataset: { title }
    } = e ? e.target : {};
    if (
      !(which === 8) &&
      !(which === 46) &&
      !(which === 37) &&
      !(which === 39)
    ) {
      e.preventDefault();
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          [title]: {
            error: true
          }
        }
      }));
    }
  };

  onChange = e => {
    const {
      value,
      dataset: { title }
    } = e.target;
    this.setState(prevState => ({
      [title]: value,
      errors: {
        ...prevState.errors,
        [title]: {
          error: !value,
          message: !value ? "Field is required" : ""
        }
      }
    }));
  };

  onBlur = e => {
    const {
      value,
      dataset: { title }
    } = e.target;
    const { mobileNumbers } = this.props.templateInfo;
    const currentVal =
      title === "toMobileNumbers"
        ? this.removeMobileNumber(mobileNumbers, value)
        : title === "cc"
        ? this.onRemoveInvalidMobileNumber(value)
        : value;
    this.setState(prevState => ({
      [title]: currentVal,
      errors: {
        ...prevState.errors,
        [title]: {
          error: !value,
          message: !value ? "Field is required" : ""
        }
      }
    }));
  };

  removeMobileNumber = (oldData, newData) => {
    const newDataArray = newData.split(",");
    let index = 0,
      arr = [];
    for (; index < newDataArray.length; index++) {
      const currentValue = newDataArray[index].trim();
      if (oldData.includes(currentValue)) {
        arr.push(currentValue);
      }
    }
    return arr;
  };

  onRemoveInvalidMobileNumber = value => {
    const valueArr = value.split(",");
    const validMobileNumber = valueArr.filter(mobile => {
      return /^[5-9]\d{9}$/gi.test(mobile.trim());
    });
    return validMobileNumber.join(",");
  };

  onSubmit = () => {
    const { toMobileNumbers, cc, message } = this.state;
    const isValid = toMobileNumbers && message;
    const { userNotificationType, tabIndex, meetingId } = this.props;
    const {
      customNotificationType,
      onSubmitClearData,
      notificationCO
    } = this.context;
    if (isValid) {
      const params = {
        meetingId,
        cc: typeof cc === "string" ? cc.split(",") : [],
        ...notificationCO,
        userNotificationType,
        customNotificationType,
        to: toMobileNumbers,
        sendBy: htmlToFormattedText("sms"),
        message: htmlToFormattedText(message)
      };
      this.setState(
        {
          isLoading: true
        },
        async () => {
          const response = await sendSmsNotificationAction(undefined, params);
          const { data } = response;
          const { status, message } = data || {};
          const state = status ? { toMails: "", message: "" } : {};
          status &&
            isFunction(onSubmitClearData) &&
            onSubmitClearData(+tabIndex);
          this.setState({ isLoading: false, ...state }, () => {
            status
              ? toast.success(
                  <p className="toast-text-alignment">{message}</p>,
                  successToastStyle
                )
              : toast.error(
                  <p className="toast-text-alignment">{message}</p>,
                  errorToastStyle
                );
          });
        }
      );
    } else {
      this.setState(prevState => ({
        errors: {
          toMobileNumbers: {
            error: !prevState.toMobileNumbers,
            message: !prevState.toMobileNumbers ? "Field is required" : ""
          },
          message: {
            error: !prevState.message,
            message: !prevState.message ? "Field is required" : ""
          }
        }
      }));
    }
  };

  onToggleUserInfo = () => {
    this.setState(prevState => ({
      displayUserInfo: !prevState.displayUserInfo
    }));
  };

  handleChange(html, event) {
    // console.log(html, event);
    this.setState({ message: html }, () => {
      this.validateMessage(); // Validate message on change
    });
  }
  handleBlur = () => {
    console.log("Editor lost focus");
    this.validateMessage();
  };
  validateMessage = () => {
    const { message } = this.state;
    console.log(message);
    if (!message || message.trim() === "<p><br></p>") {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          // message: {
          //   error: true,
          //   message: "This field is required.",
          // },
          message: {
            error: true,
            message: "Field is required"
          }
        }
      }));
    } else {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          message: {
            error: false,
            message: ""
          }
        }
      }));
    }
  };
  render() {
    const { onChange, onBlur, onKeyDown, onToggleUserInfo, onSubmit } = this;
    const {
      cc,
      errors,
      message,
      disabled,
      isLoading,
      toMobileNumbers,
      mobileNumberList,
      displayUserInfo
    } = this.state;
    console.log(errors, errors.message.message);
    const { customNotificationType } = this.context;

    const toolbarConfig = {
      toolbar: [
        ["bold", "italic", "underline", "strike"]
        //[{ list: "ordered" }, { list: "bullet" }]
      ]
    };
    const formats = [
      "header",
      "font",
      "size",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "link",
      "image",
      "video"
    ];

    return (
      <>
        <LoaderPage loading={isLoading} />
        {displayUserInfo ? (
          <UserInfo
            options={mobileNumberList}
            titles={["Name", "Mobile Numbers"]}
            onCloseModal={onToggleUserInfo}
          />
        ) : null}
        <Row noGutters={true}>
          <Col>
            <Form.Group controlId="exampleForm.ControlTextarea1">
              <Form.Label id="to">
                TO <span className="required">*</span>
                <Button
                  size="sm"
                  variant="outline-info"
                  onClick={onToggleUserInfo}
                >
                  Users Info
                </Button>
              </Form.Label>
              <Form.Control
                rows="3"
                value={toMobileNumbers}
                type="text"
                data-title="toMobileNumbers"
                onChange={onChange}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                disabled={disabled}
                isInvalid={!!errors.toMobileNumbers.error}
                tabIndex={1}
              />
              <Form.Control.Feedback type="invalid">
                <p>
                  Note: Additional mobile number can not be added. But, existing
                  mobile number can be removed from this field.
                </p>
                {errors.toMobileNumbers.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row noGutters={true}>
          <Col>
            <Form.Group controlId="exampleForm.ControlTextarea1">
              <Form.Label>Add Mobile Numbers</Form.Label>
              <Form.Control
                rows="3"
                value={cc}
                type="text"
                data-title="cc"
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
                //isInvalid={!!errors.toExtraMobileNumbers.error}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row noGutters>
          <Col>
            <Form.Group controlId="exampleForm.ControlTextarea1">
              <Form.Label>
                Message <span className="required">*</span>{" "}
                <InfoIcon
                  containerClass="email-tooltip2"
                  Template={
                    customNotificationType === "PROJECT" ? (
                      <ProjectMessageTemplate />
                    ) : customNotificationType === "ISSUE" ||
                      customNotificationType === "AGENDA" ? (
                      <IssueMessageTemplate forSMS={true} />
                    ) : null
                  }
                />
              </Form.Label>
              {/* <Form.Control
                rows="3"
                as="textarea"
                value={message}
                data-title="message"
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
                isInvalid={!!errors.message.error}
              /> */}
              <div className="email_editor sms_editor">
                <ReactQuill
                  value={message}
                  data-title="message"
                  onChange={(html, event) => this.handleChange(html, event)}
                  onBlur={this.handleBlur}
                  theme="snow"
                  modules={toolbarConfig}
                  formats={formats}
                  bounds={".app"}
                  placeholder={"Write something..."}
                  ref={el => {
                    this.reactQuillRef = el;
                  }}
                  isInvalid={!!errors.message.error}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.message.message}
              </Form.Control.Feedback>
              {errors.message.error && (
                <div className="error-message">{errors.message.message}</div>
              )}
            </Form.Group>
            {/* {message && message.length ? (
              <span className="message-count">{message.length}</span>
            ) : (
              <React.Fragment />
            )} */}
          </Col>
        </Row>
        <div class="send-btn">
          <Button size="sm" disabled={disabled} onClick={onSubmit}>
            Send
          </Button>
        </div>
      </>
    );
  }
}

export { Template };
